var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFieldInspection = function SvgFieldInspection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.61 0C122.56-.03 71.43 51.06 71.4 114.1c-.01 21.2 5.89 41.99 17.03 60.03L.17 262.73 37.45 300l88.26-88.6c53.69 33.09 124.03 16.39 157.12-37.29 33.09-53.69 16.39-124.03-37.29-157.12A114.196 114.196 0 00185.61 0zM37.42 275.13L25 262.71l13.9-13.96 12.42 12.42-13.9 13.96zm26.32-26.41L51.32 236.3l47.61-47.81c3.82 4.45 7.98 8.6 12.43 12.42l-47.62 47.81zm121.87-37.88c-53.37 0-96.64-43.27-96.64-96.64s43.27-96.64 96.64-96.64 96.64 43.27 96.64 96.64c-.07 53.35-43.3 96.58-96.64 96.64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.81 128.14L156.67 108l-12.43 12.43L176.81 153l50.14-50.14-12.43-12.43-37.71 37.71z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFieldInspection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/field-inspection.2b3ab56a.svg";
export { ForwardRef as ReactComponent };